import {Card, CardBody, IconButton, List, ListItem, Typography,} from '@material-tailwind/react';
import {setMoney} from '../../../utils/shared'
import {TrashIcon} from '@heroicons/react/24/solid';
import {toastInfo} from "../../../js/toast";
import SelectPriceComponent from "../../../components/elements/Inputs/SelectPrice";

export function ProductSelectedComponent(props) {
  const {
    items,
    removeItem,
    refNitInput,
    totalSales,
    user,
    isBill = false,
    changeValueItemSelected,
    changePriceItemSelected
  } = props;

  const setChangePrice = (value, dataPrice) => {
    changePriceItemSelected(
      dataPrice,
      dataPrice.options_prices.find((price) => parseInt(price.price_type) === parseInt(value))?.amount ?? 0
    )
  }

  function numberOnly(idInput) {
    let element = document.getElementById(idInput);
    const regex = /^\d*\.?\d*$/;
    if (`${element.value}`.startsWith("0")) {
      element.value = parseInt(`${element.value}`.replace('0', ''))
    } else if (regex.test(element.value)) {
    } else {
      element.value = element.value.replace(/\D/g, '');
    }
  }

  function validarRoles() {
    return !(user.role_id === 4 || user.views === "is_superuser");
  }

  return (
    <Card className='border rounded-none border-black/40 min-h-[500px]'>
      <CardBody className='px-2'>
        <List className='px-0'>
          {/* ***************** HEADER  *****************  */}
          <ListItem
            ripple={false}
            className="hover:bg-blue-gray-50/100 border md:xl:lg:2xl:grid md:xl:lg:2xl:grid-cols-12 bg-blue-gray-50 opacity-100  pt-1 pb-1 hidden rounded-none text-[13px] font-bold">
            <div className='col-span-5 text-justify text-black'>
              Producto
            </div>
            <div className='col-span-2 pl-2 ml-0 text-black'>
              Cantidad
            </div>
            <div className='col-span-2 text-right text-black'>
              Precio
            </div>
            <div className='col-span-2 text-right text-black'>
              Subtotal
            </div>
            <div className='col-span-1 text-right text-black'>
            </div>
          </ListItem>
          {/* ***************** ITEMS  *****************  */}
          {
            items.length ? items.map((item, index) => (
                <ListItem
                  ripple={false}
                  key={index}
                  className="px-2 pt-0 hover:bg-transparent cursor-default gap-1 pb-1 border-b border-gray-500 rounded-none grid grid-cols-12 text-[12px] text-black product-select">
                  <div className='col-span-12 lg:xl:2xl:col-span-5 flex text-justify justify-between'>
                    <span className='block lg:md:2xl:xl:hidden text-sm font-bold'>Producto: </span>
                    {item.name}
                  </div>
                  <div className='col-span-12 flex lg:col-span-2 gap-2 justify-between'>
                    <span className='lg:md:2xl:xl:hidden text-sm font-bold w-60'>Cantidad: </span>
                    <button
                      type="button"
                      disabled={item.quantity === 1}
                      onClick={() => changeValueItemSelected(item, item.quantity - 1)}
                      className="border border-blue-gray-200 px-2">-
                    </button>
                    <input
                      id={`quantity-${index}`}
                      type="number"
                      onInput={() => numberOnly(`quantity-${index}`)}
                      className='w-full'
                      onChange={(change) => {
                        const value = parseInt(change.target.value ?? 0);
                        if (!value) {
                          changeValueItemSelected(item, 0)
                        } else if (!isNaN(value) && value >= 0) {
                          if (value <= item.stock) {
                            changeValueItemSelected(item, value)
                          } else {
                            toastInfo(`Solo existen disponibles ${item.stock} ${item.name} `);
                          }
                        }
                      }}
                      value={item.quantity}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const value = parseInt(item.quantity);
                        const stock = item.stock;
                        if (!isNaN(value) && value >= 0) {
                          if (value < stock) {
                            changeValueItemSelected(item, value + 1);
                          } else {
                            toastInfo(`Solo existen disponibles ${stock} ${item.name} `);
                          }
                        }
                      }}
                      className="border border-blue-gray-200 px-2">+
                    </button>
                  </div>
                  <div
                    className='col-span-12 flex justify-end lg:md:2xl:xl:col-span-2 text-right lg:md:2xl:xl:justify-end'>
                    <span className='block lg:md:2xl:xl:hidden text-sm font-bold'>Subtotal: </span>
                    {/*{setMoney(item.price * 1)}*/}
                    <SelectPriceComponent
                      isDisabled={validarRoles()}
                      setChangePrice={(precioSeleccionado) => setChangePrice(precioSeleccionado, item)}
                      options={item?.options_prices}
                    />
                  </div>
                  <div
                    className='col-span-12 flex justify-between lg:md:2xl:xl:col-span-2 text-right  lg:md:2xl:xl:justify-end'>
                    <span className='block lg:md:2xl:xl:hidden text-sm font-bold'>Total: </span>
                    {setMoney(item.price * item.quantity)}
                  </div>

                  <div className='col-span-12 lg:col-span-1 md:col-span-1 2xl:col-span-1 xl:col-span-1 text-right'>
                    <IconButton className='icon-del-item h-6 bg-transparent' onClick={() => removeItem(item.id)}>
                      <TrashIcon className='w-5 h-5 text-deep-orange-500'/>
                    </IconButton>
                  </div>
                </ListItem>
              ))
              :
              <div className='w-full text-center'>
                <Typography variant='paragraph' color='amber'>Aun no has ingresado productos</Typography>
              </div>
          }
        </List>
        <p className='w-full grid-cols-12 lg:md:xl:2xl:grid lg:md:xl:2xl:text-right text-right'>
          <strong
            className='lg:md:xl:2xl:col-span-3 lg:md:xl:2xl:col-start-8 lg:md:xl:2xl:col-end-12 text-right text-black'>
            Total: {totalSales}
          </strong>
        </p>
      </CardBody>

    </Card>
  )

}
